/**
 * @generated SignedSource<<3712a2b0851049d763d4d7842b1956ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTable_spreadsheetGroupConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly firstGroup?: {
    readonly id: string;
    readonly issues: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly issueId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody">;
  readonly " $fragmentType": "IssueTable_spreadsheetGroupConnection";
};
export type IssueTable_spreadsheetGroupConnection$key = {
  readonly " $data"?: IssueTable_spreadsheetGroupConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable_spreadsheetGroupConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "viewConfigInput"
    }
  ],
  "kind": "Fragment",
  "name": "IssueTable_spreadsheetGroupConnection",
  "selections": [
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraSpreadsheetGroup",
              "kind": "LinkedField",
              "name": "firstGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "fieldSetsInput",
                      "variableName": "fieldSetsInput"
                    },
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 50
                    },
                    {
                      "kind": "Variable",
                      "name": "scope",
                      "variableName": "fieldSetsScope"
                    },
                    {
                      "kind": "Variable",
                      "name": "settings",
                      "variableName": "settings"
                    },
                    (v1/*: any*/)
                  ],
                  "concreteType": "JiraIssueConnection",
                  "kind": "LinkedField",
                  "name": "issues",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraIssue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "issueId"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "concreteType": "PageInfo",
                      "kind": "LinkedField",
                      "name": "pageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "hasNextPage"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isEditableSyncLoaded",
          "variableName": "isEditableSyncLoaded"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isLinkRelationshipFieldEnabled",
          "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
          "kind": "Variable",
          "name": "isPaginating",
          "variableName": "isPaginating"
        },
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        },
        {
          "kind": "Variable",
          "name": "isTimelineEnabled",
          "variableName": "isTimelineEnabled"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        (v1/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "GroupTableBody"
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};
})();

(node as any).hash = "84e7d002a390b7e49a676c26e9fa1ad0";

export default node;
